import Vue from 'vue'
import Router from 'vue-router'
import { isStaleChunkRouterError, reloadOnceForStaleChunk, clearReloadGuard } from '@/helpers/staleChunk'
import { ADMIN_PLUS_ROLES } from '@/constants/roles'
import { staffGateRedirect } from '@/router/staffGate'
import { renGateRedirect } from '@/router/renGate'
import { rentalObjectGateRedirect } from '@/router/rentalObjectGate'
import { signinRedirectFor } from '@/router/authRedirect'
import { DEFAULT_API_BASE } from '@/utils/apiBase'
import { oauthApiBaseForRoute, oauthSessionMatchesApi } from '@/utils/oauthFlow'
// import firebase from 'firebase/app'
// import "firebase/auth";
import Home from '@/components/Home'
import { store } from '@/store/store'
import { navigationBlocked } from '@/utils/deviceLock'
import Signin from '@/components/Signin'
import Signup from '@/components/Signup'
import UsersList from '@/components/admin/users/List'
import UserEdit from '@/components/admin/users/Edit'
import Salary from '@/components/dashboard/users/Salary'
import Operations from '@/components/dashboard/operations/Operations'
import ForgotPassword from '@/components/ForgotPassword'
import ResetPassword from '@/components/ResetPassword'
import Cars from '@/components/dashboard/cars/Cars.vue'
import Bookings from '@/components/dashboard/bookings/Bookings.vue'
import ArchiveBookings from '@/components/dashboard/bookings/ArchiveBookings.vue'
import NewCars from '@/components/dashboard/cars/New.vue'
import CarCard from '@/components/dashboard/cars/CarCard.vue'
import ArchiveCars from '@/components/dashboard/cars/ArchiveCars.vue'
import NewBooking from '@/components/dashboard/bookings/NewBooking.vue'
import SearchFree from '@/components/dashboard/bookings/SearchFree.vue'
import BookingCard from '@/components/dashboard/bookings/BookingCard.vue'
import BookingsBoard from '@/components/dashboard/bookings/BookingsBoard.vue'
import BookingsListView from '@/components/dashboard/bookings/BookingsListView.vue'
import Clients from '@/components/dashboard/clients/Clients.vue'
import ClientCard from '@/components/dashboard/clients/ClientCard.vue'
import WhatsAppChat from '@/components/dashboard/clients/WhatsAppChat.vue'
import WhatsAppClient from '@/components/dashboard/clients/WhatsAppClient.vue'
import NewClient from '@/components/dashboard/clients/NewClient.vue'
import Invoices from '@/components/dashboard/clients/Invoices.vue'
import NewCalendar from '@/components/dashboard/calendars/NewCalendar.vue'
import TimelineCalendar from '@/components/dashboard/calendars/TimelineCalendar.vue'
import ShiftTimeline from '@/components/dashboard/calendars/shift-timeline/ShiftTimeline.vue'
import Counts from '@/components/dashboard/counts/Counts.vue'
import Fines from '@/components/dashboard/clients/Fines.vue'
import NewFine from '@/components/dashboard/clients/NewFine.vue'
import Debts from '@/components/dashboard/clients/Debts.vue'
import CompanyCounts from '@/components/dashboard/counts/CompanyCounts.vue'
import NewCount from '@/components/dashboard/counts/NewCount.vue'
import ServiceTech from '@/components/dashboard/services/ServiceTech.vue'
import ServiceInsurance from '@/components/dashboard/services/ServiceInsurance.vue'
import ServicePayments from '@/components/dashboard/services/ServicePayments.vue'
import Profile from '@/components/dashboard/users/Profile.vue'
import Analitics from '@/components/dashboard/analitics/Analitics.vue'
import CompanyReports from '@/components/dashboard/analitics/CompanyReports.vue'
import ClientsReports from '@/components/dashboard/analitics/ClientsReports.vue'
import CarsReports from '@/components/dashboard/analitics/CarsReports.vue'
import WorkersReports from '@/components/dashboard/analitics/WorkersReports.vue'
import BookingsReports from '@/components/dashboard/analitics/BookingsReports.vue'
import CompanyProfile from '@/components/dashboard/users/CompanyProfile.vue'
import CreateEmployee from '@/components/dashboard/users/CreateEmployee.vue'
import Locations from '@/components/dashboard/locations/Locations.vue'
// Transactions
import Transactions from '@/components/dashboard/transactions/Transactions.vue'
import ResultSuccess from '@/components/dashboard/transactions/ResultSuccess.vue'
import ResultBad from '@/components/dashboard/transactions/ResultBad.vue'
// Склад
import Store from '@/components/dashboard/store/Store.vue'
// Тарифы
import Tariffs from '@/components/dashboard/tariffs/Tariffs.vue'
// Инвесторы
import NewInvestor from '@/components/dashboard/investors/NewInvestor.vue'
import Investors from '@/components/dashboard/investors/Investors.vue'
import InvestorsArchive from '@/components/dashboard/investors/InvestorsArchive.vue'
import Investor from '@/components/dashboard/investors/Investor.vue'
import InvestorAnalytics from '@/components/dashboard/investors/InvestorAnalytics.vue'
// Филиалы
import Branches from '@/components/dashboard/branches/Branches.vue'
// Контрагенты
import Contractors from '@/components/dashboard/branches/Contractors.vue'
import Contractor from '@/components/dashboard/branches/ContractorCard.vue'
// Шаблоны
import DocTemplate from '@/components/dashboard/templates/DocTemplate.vue'
// Help
import QuickStart from '@/components/dashboard/help/QuickStart.vue'
import DocCreation from '@/components/dashboard/help/DocCreation.vue'
import AddCar from '@/components/dashboard/help/AddCar.vue'
import Widget from '@/components/dashboard/help/Widget.vue'
import UsersRoles from '@/components/dashboard/help/UsersRoles.vue'
import FunctionsDesc from '@/components/dashboard/help/FunctionsDesc.vue'
import Problems from '@/components/dashboard/help/Problems.vue'
import Faqs from '@/components/dashboard/help/Faqs.vue'
import DocVariables from '@/components/dashboard/help/DocVariables.vue'
// Agents
import AgentsList from '@/components/dashboard/agents/AgentsList'
import CreateAgent from '@/components/dashboard/agents/CreateAgent'
import EditAgent from '@/components/dashboard/agents/EditAgent'
import AgentCard from '@/components/dashboard/agents/AgentCard'
// Agregator
import BookingSettings from '@/components/dashboard/agregator/BookingSettings.vue'
// Clietn Page
import ClientPage from '@/components/dashboard/clients/ClientPage.vue'
import ClientResult from '@/components/dashboard/clients/client_page/ClientResult.vue'
import http404 from '@/components/http404.vue'
import TeletypeClient from '@/components/dashboard/clients/TeletypeClient.vue'
import TeletypePage from '@/components/dashboard/clients/TeletypePage.vue'
// Support
import SupportTickets from '@/components/dashboard/support/SupportTickets.vue'
import SupportTicketDetail from '@/components/dashboard/support/SupportTicketDetail.vue'
// AI Assistant
import AiAssistant from '@/components/dashboard/ai/AiAssistant.vue'
// ConfirmDialogTest
import ConfirmDialogTest from '@/components/dialogs_examples/ConfirmDialogTest.vue'

Vue.use(Router)

const routes = [
    {
        path: '/',
        redirect: '/dashboard',
        meta: { requiresAuth: true }
    },
    {
        path: '/signin',
        name: 'Signin',
        component: Signin,
        meta: { requiresAuth: false }
    },
    {
        path: '/oauth/consent',
        name: 'OAuthConsent',
        component: () => import(/* webpackChunkName: "oauth-consent" */ '@/components/oauth/OAuthConsent.vue'),
        meta: { requiresAuth: true }
    },
    // FT-200 (REQ-11, CTR-03): возврат из банка после оплаты и привязки карты. «Набор возврата»: маршрут остаётся
    // и при откате vue к старому кабинету — банк хранит этот адрес у операций (resultIsolation.spec.js).
    {
        path: '/client_page/result',
        name: 'ClientResult',
        component: ClientResult,
        meta: { requiresAuth: false }
    },
    {
        path: '/client_page',
        name: 'ClientPage',
        component: ClientPage,
        meta: { requiresAuth: false }
    },
    {
        path: '/dashboard',
        name: 'Home',
        component: Home,
        meta: { requiresAuth: true }
    },
    {
        path: '/signup',
        name: 'Signup',
        component: Signup,
        meta: { requiresAuth: false }
    },
    {
        path: '/forgot_password',
        name: 'ForgotPassword',
        component: ForgotPassword,
        meta: { requiresAuth: false }
    },
    {
        path: '/reset_password/:token',
        name: 'ResetPassword',
        component: ResetPassword,
        meta: { requiresAuth: false }
    },
    {
        path: '/tasks',
        name: 'Tasks',
        component: () => import(/* webpackChunkName: "tasks" */ '@/components/dashboard/tasks/TasksView.vue'),
        // requiresStaff: зеркало Api::V1::TasksController#ensure_staff!. Без него
        // прямой заход по URL/закладке монтировал TasksBoard любой роли, и его
        // created() бил в #index и #users — пара 403. В прод-логах этот путь не
        // встречается: все отказы там несут taskable_type, то есть приходят из
        // TaskList внутри карточек (закрыт в ea589940). Гейт закрывает вход,
        // который до прода пока не доходил, а не наблюдавшийся инцидент.
        meta: { requiresAuth: true, requiresStaff: true }
    },
    {
        path: '/cars',
        name: 'Cars',
        component: Cars,
        meta: { requiresAuth: true }
    },
    {
        path: '/objects',
        name: 'Objects',
        component: Cars,
        meta: { requiresAuth: true }
    },
    {
        path: '/cars/new',
        name: 'newCars',
        component: NewCars,
        meta: { requiresAuth: true }
    },
    {
        path: '/vehicles/board',
        name: 'CarsBoard',
        component: () => import(/* webpackChunkName: "cars-board" */ '@/components/dashboard/cars/CarsBoard.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/vehicles/list',
        name: 'CarsList',
        component: () => import(/* webpackChunkName: "cars-board" */ '@/components/dashboard/cars/CarsListView.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/cars/:id',
        name: 'CarCard',
        component: CarCard,
        meta: { requiresAuth: true }
    },
    {
        path: '/archive_cars',
        name: 'ArchiveCars',
        component: ArchiveCars,
        meta: { requiresAuth: true }
    },
    {
        path: '/bookings',
        name: 'Bookings',
        component: Bookings,
        meta: { requiresAuth: true }
    },
    {
        path: '/bookings/board',
        name: 'BookingsBoard',
        component: BookingsBoard,
        meta: { requiresAuth: true }
    },
    {
        path: '/bookings/list',
        name: 'BookingsList',
        component: BookingsListView,
        meta: { requiresAuth: true }
    },
    {
        path: '/archive_bookings',
        name: 'ArchiveBookings',
        component: ArchiveBookings,
        meta: { requiresAuth: true }
    },
    {
        path: '/bookings/:id',
        name: 'BookingCard',
        component: BookingCard,
        meta: { requiresAuth: true }
    },
    {
        path: '/booking/new',
        name: 'NewBooking',
        component: NewBooking,
        meta: { requiresAuth: true }
    },
    {
        path: '/search_free',
        name: 'SearchFree',
        component: SearchFree,
        meta: { requiresAuth: true }
    },
    {
        path: '/investors/new',
        name: 'NewInvestor',
        component: NewInvestor,
        meta: { requiresAuth: true }
    },
    {
        path: '/investors',
        name: 'Investors',
        component: Investors,
        meta: { requiresAuth: true }
    },
    {
        path: '/investors_archive',
        name: 'InvestorsArchive',
        component: InvestorsArchive,
        meta: { requiresAuth: true }
    },
    {
        path: '/investor_analytics',
        name: 'InvestorAnalytics',
        component: InvestorAnalytics,
        meta: { requiresAuth: true }
    },
    {
        path: '/branches',
        name: 'Branches',
        component: Branches,
        meta: { requiresAuth: true }
    },
    {
        path: '/contractors',
        name: 'Contractors',
        component: Contractors,
        meta: { requiresAuth: true }
    },
    {
        path: '/contractors/:id',
        name: 'Contractor',
        component: Contractor,
        meta: { requiresAuth: true }
    },
    {
        path: '/investors/:id',
        name: 'Investor',
        component: Investor,
        meta: { requiresAuth: true }
    },
    {
        path: '/tariffs',
        name: 'Tariffs',
        component: Tariffs,
        meta: { requiresAuth: true }
    },
    {
        path: '/admin/users',
        name: 'UsersList',
        component: UsersList,
        meta: { requiresAuth: true }
    },
    {
        path: '/admin/users/:id',
        name: 'UserEdit',
        component: UserEdit,
        meta: { requiresAuth: true }
    },
    {
        path: '/clients',
        name: 'Clients',
        component: Clients,
        meta: { requiresAuth: true }
    },
    {
        path: '/clients/:id',
        name: 'ClientCard',
        component: ClientCard,
        meta: { requiresAuth: true }
    },
    {
        path: '/agents',
        name: 'AgentsList',
        component: AgentsList,
        meta: { requiresAuth: true }
    },
    {
        path: '/agent_card/:id',
        name: 'AgentCard',
        component: AgentCard,
        meta: { requiresAuth: true }
    },
    {
        path: '/create_agent',
        name: 'CreateAgent',
        component: CreateAgent,
        meta: { requiresAuth: true }
    },
    {
        path: '/agents/:id',
        name: 'EditAgent',
        component: EditAgent,
        meta: { requiresAuth: true }
    },
    {
        path: '/whatsapp_chat',
        name: 'WhatsAppChat',
        component: WhatsAppChat,
        // FT-195: прокси чата на сервере пускает только штат (partner, agent, guest — 403).
        meta: { requiresAuth: true, requiresStaff: true }
    },
    {
        path: '/whatsapp_client/:id',
        name: 'WhatsAppClient',
        component: WhatsAppClient,
        meta: { requiresAuth: true, requiresStaff: true }
    },
    {
        path: '/client/new',
        name: 'NewClient',
        component: NewClient,
        meta: { requiresAuth: true }
    },
    {
        path: '/invoices',
        name: 'Invoices',
        component: Invoices,
        meta: { requiresAuth: true }
    },
    {
        path: '/invoices/:query',
        name: 'InvoicesWithQuery',
        component: Invoices,
        meta: { requiresAuth: true }
    },
    {
        path: '/calendars/new',
        name: 'NewCalendar',
        component: NewCalendar,
        meta: { requiresAuth: true }
    },
    {
        path: '/calendars/timeline',
        name: 'TimelineCalendar',
        component: TimelineCalendar,
        meta: { requiresAuth: true }
    },
    {
        path: '/calendars/gantt',
        name: 'GanttCalendar',
        component: () => import('@/components/dashboard/calendars/GanttCalendar.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/counts',
        name: 'Counts',
        component: Counts,
        meta: { requiresAuth: true }
    },
    {
        path: '/company_counts',
        name: 'CompanyCounts',
        component: CompanyCounts,
        meta: { requiresAuth: true }
    },
    {
        path: '/company_counts/:query',
        name: 'CompanyCountsWithQuery',
        component: CompanyCounts,
        meta: { requiresAuth: true }
    },
    {
        path: '/counts/new',
        name: 'NewCount',
        component: NewCount,
        meta: { requiresAuth: true }
    },
    {
        path: '/fines',
        name: 'Fines',
        component: Fines,
        meta: { requiresAuth: true }
    },
    {
        path: '/fines/:query',
        name: 'FinesWithQuery',
        component: Fines,
        meta: { requiresAuth: true }
    },
    {
        path: '/new_fine',
        name: 'NewFine',
        component: NewFine,
        meta: { requiresAuth: true }
    },
    {
        path: '/debts',
        name: 'Debts',
        component: Debts,
        meta: { requiresAuth: true }
    },
    {
        path: '/debts/:query',
        name: 'DebtsWithQuery',
        component: Debts,
        meta: { requiresAuth: true }
    },
    {
        path: '/service_tech',
        name: 'ServiceTech',
        component: ServiceTech,
        meta: { requiresAuth: true }
    },
    {
        path: '/service_payments',
        name: 'ServicePayments',
        component: ServicePayments,
        meta: { requiresAuth: true }
    },
    {
        path: '/service_insurance',
        name: 'ServiceInsurance',
        component: ServiceInsurance,
        meta: { requiresAuth: true }
    },
    {
        path: '/profile',
        name: 'Profile',
        component: Profile,
        meta: { requiresAuth: true }
    },
    {
        path: '/salary',
        name: 'Salary',
        component: Salary,
        meta: { requiresAuth: true }
    },
    {
        path: '/history',
        name: 'Operations',
        component: Operations,
        meta: { requiresAuth: true }
    },
    {
        path: '/company_profile',
        name: 'CompanyProfile',
        component: CompanyProfile,
        meta: { requiresAuth: true }
    },
    {
        path: '/analitics',
        name: 'Analitics',
        component: Analitics,
        meta: { requiresAuth: true }
    },
    {
        path: '/company_reports/:query',
        name: 'CompanyReports',
        component: CompanyReports,
        meta: { requiresAuth: true }
    },
    {
        path: '/clients_reports/:query',
        name: 'ClientsReports',
        component: ClientsReports,
        meta: { requiresAuth: true }
    },
    {
        path: '/cars_reports/:query',
        name: 'CarsReports',
        component: CarsReports,
        meta: { requiresAuth: true }
    },
    {
        path: '/workers_reports/:query',
        name: 'WorkersReports',
        component: WorkersReports,
        meta: { requiresAuth: true }
    },
    {
        path: '/bookings_reports/:query',
        name: 'BookingsReports',
        component: BookingsReports,
        meta: { requiresAuth: true }
    },
    {
        path: '/create_employee',
        name: 'CreateEmployee',
        component: CreateEmployee,
        meta: { requiresAuth: true }
    },
    {
        path: '/locations',
        name: 'Locations',
        component: Locations,
        meta: { requiresAuth: true }
    },
    {
        path: '/schedule_calendar',
        // FT-089: имя роута заморожено (Drawer/AppHeader ходят по имени), компонент новый
        name: 'ScheduleCalendar',
        component: ShiftTimeline,
        meta: { requiresAuth: true }
    },
    {
        path: '/store',
        name: 'Store',
        component: Store,
        meta: { requiresAuth: true }
    },
    {
        path: '/doc_template',
        name: 'DocTemplate',
        component: DocTemplate,
        meta: { requiresAuth: true }
    },
    {
        path: '/transactions',
        name: 'Transactions',
        component: Transactions,
        meta: { requiresAuth: true }
    },
    {
        // FT-071: дедик-путь возврата из Stripe Checkout (universal link). iOS AASA разрешает /*
        // КРОМЕ /transactions|/signup|… — поэтому возвращаемся на /app-return (в allowlist), а в
        // приложении/вебе редиректим в Транзакции, сохраняя ?stripe_autopay (его ловит return-хендлер).
        path: '/app-return',
        redirect: (to) => ({ path: '/transactions', query: to.query })
    },
    {
        path: '/result_success',
        name: 'ResultSuccess',
        component: ResultSuccess,
        props: true,
        meta: { requiresAuth: false }
    },
    {
        path: '/result_bad',
        name: 'ResultBad',
        component: ResultBad,
        props: true,
        meta: { requiresAuth: false }
    },
    {
        path: '/help/quick_start',
        name: 'QuickStart',
        component: QuickStart,
        meta: { requiresAuth: true }
    },
    {
        path: '/help/doc_creation',
        name: 'DocCreation',
        component: DocCreation,
        meta: { requiresAuth: true }
    },
    {
        path: '/help/add_car',
        name: 'AddCar',
        component: AddCar,
        meta: { requiresAuth: true }
    },
    {
        path: '/help/widget',
        name: 'Widget',
        component: Widget,
        meta: { requiresAuth: true }
    },
    {
        path: '/help/problems',
        name: 'Problems',
        component: Problems,
        meta: { requiresAuth: true }
    },
    {
        path: '/help/roles',
        name: 'UsersRoles',
        component: UsersRoles,
        meta: { requiresAuth: true }
    },
    {
        path: '/help/functions_desc',
        name: 'FunctionsDesc',
        component: FunctionsDesc,
        meta: { requiresAuth: true }
    },
    {
        path: '/help/faqs',
        name: 'Faqs',
        component: Faqs,
        meta: { requiresAuth: true }
    },
    {
        path: '/help/doc_variables',
        name: 'DocVariables',
        component: DocVariables,
        meta: { requiresAuth: true }
    },
    {
        path: '/agregator/settings',
        name: 'BookingSettings',
        component: BookingSettings,
        meta: { requiresAuth: true }
    },
    {
        path: '/teletype',
        name: 'Teletype',
        component: TeletypePage,
        meta: { requiresAuth: true }
    },
    {
        path: '/clients/:id/teletype',
        name: 'TeletypeClient',
        component: TeletypeClient,
        meta: { requiresAuth: true }
    },
    {
        path: '/support/tickets',
        name: 'SupportTickets',
        component: SupportTickets,
        meta: { requiresAuth: true }
    },
    {
        path: '/support/tickets/:id',
        name: 'SupportTicketDetail',
        component: SupportTicketDetail,
        meta: { requiresAuth: true }
    },
    {
        path: '/ai-assistant',
        name: 'AiAssistant',
        component: AiAssistant,
        // requiresRen: Ren недоступен partner и agent (FT-199) — решение в @/router/renGate
        meta: { requiresAuth: true, requiresRen: true }
    },
    {
        path: '/confirm_dialog_test',
        name: 'ConfirmDialogTest',
        component: ConfirmDialogTest,
        meta: { requiresAuth: true }
    },
    {
        path: "/crm/leads",
        name: "crm-leads",
        component: () => import(/* webpackChunkName: "crm-leads" */ "@/components/dashboard/crm/CrmLeadsPage.vue"),
        meta: { requiresAuth: true, requiresCrm: true },
    },
    {
        path: "/crm/leads/:id",
        name: "crm-lead",
        component: () => import(/* webpackChunkName: "crm-leads" */ "@/components/dashboard/crm/CrmLeadsPage.vue"),
        meta: { requiresAuth: true, requiresCrm: true },
    },
    {
        path: "/crm/leads/:id/convert",
        name: "crm-lead-convert",
        component: () => import(/* webpackChunkName: "crm-leads" */ "@/components/dashboard/crm/convert/CrmLeadConvertWorkspace.vue"),
        meta: { requiresAuth: true, requiresCrm: true },
    },
    {
        path: "/crm/settings",
        name: "crm-settings",
        component: () => import(/* webpackChunkName: "crm-leads" */ "@/components/dashboard/crm/CrmSettingsPage.vue"),
        meta: { requiresAuth: true, requiresCrm: true },
    },
    {
        path: "/website_chats",
        name: "website-chats",
        component: () => import(/* webpackChunkName: "website-chats" */ "@/components/dashboard/website_chats/WebsiteChatsPage.vue"),
        // The page preserves the existing CRM-module + admin settings gate.
        meta: { requiresAuth: true },
    },
    {
        path: "/booking_widgets",
        name: "booking-widgets",
        component: () => import(/* webpackChunkName: "booking-widgets" */ "@/components/dashboard/booking_widgets/BookingWidgetsList.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: "/booking_widgets/new",
        name: "booking-widget-new",
        component: () => import(/* webpackChunkName: "booking-widgets" */ "@/components/dashboard/booking_widgets/BookingWidgetEditor.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: "/booking_widgets/:id",
        name: "booking-widget",
        component: () => import(/* webpackChunkName: "booking-widgets" */ "@/components/dashboard/booking_widgets/BookingWidgetEditor.vue"),
        meta: { requiresAuth: true },
    },
    // FT-173 REQ-02: модуль «Аренда с выкупом». "new" объявлен раньше ":id" —
    // иначе vue-router отдал бы литерал "new" маршруту ":id" (страница
    // договора с id="new" вместо мастера).
    {
        path: "/rent_to_own/contracts",
        name: "rent-to-own-contracts",
        component: () => import(/* webpackChunkName: "rent-to-own" */ "@/components/dashboard/rent_to_own/ContractsList.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: "/rent_to_own/contracts/new",
        name: "rent-to-own-contract-new",
        component: () => import(/* webpackChunkName: "rent-to-own" */ "@/components/dashboard/rent_to_own/ContractWizard.vue"),
        meta: { requiresAuth: true },
    },
    // FT-173 REQ-05 (решение USER 2026-09-25): правка черновика — тот же
    // мастер, id договора пропом.
    {
        path: "/rent_to_own/contracts/:id/edit",
        name: "rent-to-own-contract-edit",
        component: () => import(/* webpackChunkName: "rent-to-own" */ "@/components/dashboard/rent_to_own/ContractWizard.vue"),
        props: true,
        meta: { requiresAuth: true },
    },
    {
        path: "/damage_control/bookings/:booking_id/act",
        name: "damage-control-act",
        component: () => import(/* webpackChunkName: "damage-control" */ "@/components/dashboard/damage_control/act/ActPage.vue"),
        props: true,
        meta: { requiresAuth: true },
    },
    {
        path: "/rent_to_own/contracts/:id",
        name: "rent-to-own-contract",
        component: () => import(/* webpackChunkName: "rent-to-own" */ "@/components/dashboard/rent_to_own/ContractPage.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: "/rent_to_own/products",
        name: "rent-to-own-products",
        component: () => import(/* webpackChunkName: "rent-to-own" */ "@/components/dashboard/rent_to_own/Products.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: '/notifications',
        name: 'Notifications',
        component: () => import('@/components/notifications/NotificationsPage.vue'),
        meta: { requiresAuth: true }
    },
    // FT-184 REQ-16: операции агентов, ждущие одобрения владельца ключа. Сюда ведёт
    // уведомление AgentOperationPendingNotifier в колокольчике (url "/agent_operations").
    {
        path: '/agent_operations',
        name: 'AgentOperations',
        component: () => import(/* webpackChunkName: "agent-operations" */ '@/components/agents/AgentOperationsPending.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: "/404",
        name: "http404",
        component: http404,
        meta: { requiresAuth: false }
    },
    {
        path: '*',
        redirect: '/404'
    }
]

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: routes
})
router.beforeEach((from, to, next) => {
    // FT-191: на заблокированном общем компьютере переходов нет.
    if (navigationBlocked({ locked: store.getters['deviceLock/locked'], tabClosed: store.getters['deviceLock/tabClosed'] })) {
        return next(false);
    }
    const requiresAuth = from.matched.some(record => record.meta.requiresAuth);
    // const isAuthenticated = firebase.auth().currentUser;
    const isAuthenticated = localStorage.getItem('auth_token');
    const oauthApiBase = from.path === '/oauth/consent'
        ? oauthApiBaseForRoute(from, DEFAULT_API_BASE)
        : null;
    // Неизвестный cell обязан дойти до локального invalid-link экрана без signin
    // и без HTTP. Компонент повторяет ту же проверку перед любым запросом.
    if (from.path === '/oauth/consent' && !oauthApiBase) {
        next();
        return;
    }
    // JWT сохранённой другой ячейки не отправляем в API заявки. Сначала чистим
    // сессию без побочной навигации мутации, затем сохраняем полный OAuth from.
    const sessionApiBase = store.state.api_url || DEFAULT_API_BASE;
    if (oauthApiBase && isAuthenticated && !oauthSessionMatchesApi(sessionApiBase, oauthApiBase)) {
        store.commit('unsetCurrentUser', { navigate: false });
        next(signinRedirectFor(from.fullPath));
        return;
    }
    const referral_code = from.query.ref;
    if (referral_code) {
        localStorage.setItem('referral_code', referral_code);
    }
    //   console.log("isauthenticated", isAuthenticated);
    if (requiresAuth && !isAuthenticated) {
        // Объект, не строка: иначе query/hash исходного пути теряются (см. authRedirect.js).
        next(signinRedirectFor(from.fullPath));
    } else {
        // Staff gate (requiresStaff) — зеркало Api::V1::TasksController#ensure_staff!.
        // NB: `from` is destination in this guard's inverted signature.
        // Решение вынесено в @/router/staffGate — там же обоснование allowlist'а
        // и fail-open на пустой роли, и оттуда же оно тестируется поведенчески.
        const requiresStaff = from.matched.some((r) => r.meta.requiresStaff);
        if (requiresStaff) {
            const staffUser = store.getters.getCurrentUser;
            const staffRedirect = staffGateRedirect(staffUser && staffUser.role);
            if (staffRedirect) { next(staffRedirect); return; }
        }
        // Ren gate (requiresRen): partner и agent — на Home. Решение и обоснование — @/router/renGate.
        const requiresRen = from.matched.some((r) => r.meta.requiresRen);
        if (requiresRen) {
            const renUser = store.getters.getCurrentUser;
            const renRedirect = renGateRedirect(renUser && renUser.role);
            if (renRedirect) { next(renRedirect); return; }
        }
        // FT-183: разделы, скрытые для типа техники компании (штрафы, страховки ТС,
        // агрегатор у вело-компании). Решение — в @/router/rentalObjectGate.
        const rentalObjectRedirect = rentalObjectGateRedirect(from.path, store.getters.getCompany);
        if (rentalObjectRedirect) { next(rentalObjectRedirect); return; }
        // CRM gate (requiresCrm). NB: `from` is destination in this guard's inverted signature.
        const requiresCrm = from.matched.some((r) => r.meta.requiresCrm);
        if (requiresCrm) {
            const mc = store.getters.getMainCompany;
            // FT-081: гейт доступа = crm_active (add-on), НЕ plan.included_services (право).
            const moduleOn = !!(mc && mc.crm_active);
            const user = store.getters.getCurrentUser;
            const accessOn = !!(user && user.crm_access_enabled === true);
            const trialAvailable = !!(mc && mc.crm_trial_available);
            // Имя isAdmin здесь означало «admin ИЛИ superadmin» — то же
            // затенение, что снято в AnnouncementBar, но в маршрутизации.
            // Берём ярус из констант, чтобы список ролей был один на проект.
            const isAdminPlus = !!(user && ADMIN_PLUS_ROLES.includes(user.role));
            if (!moduleOn) {
                // FT-081: тариф предлагает CRM, триал не брали — пускаем на страницу показать intro+кнопку «Подключить».
                if (trialAvailable && isAdminPlus) { next(); return; }
                next({ name: "Home", query: { error: "crm_module_disabled" } }); return;
            }
            if (!accessOn) { next({ name: "Home", query: { error: "crm_access_denied" } }); return; }
        }
        next();
    }
});

// Восстановление после устаревшего SPA-shell: провал загрузки ленивого чанка после
// передеплоя фронта (см. @/helpers/staleChunk). Guarded-reload не чаще раза в 10с.
router.onError((err) => {
    if (isStaleChunkRouterError(err)) {
        reloadOnceForStaleChunk();
    }
});

// Успешная навигация = shell жив → сбрасываем guard, чтобы восстановление работало
// и на будущих деплоях, а не «сгорало» после первого раза за сессию.
router.afterEach(() => {
    if (typeof window !== 'undefined' && window.sessionStorage) {
        clearReloadGuard(window.sessionStorage);
    }
});

export default router
